import Select from 'antd/lib/select';
import { CgChevronDown } from 'react-icons/cg';
import { ISelectAutocompleteProps } from './ISelectAutocomplete';
import { ReactComponent as SpanIcon } from '../../assets/svg/spam.svg';

function SelectAutocomplete({
    label,
    onSearch,
    onFetchDataResults,
    error,
    helperText,
    dataTestId,
    ...props
}: Readonly<ISelectAutocompleteProps>): JSX.Element {
    const handleSearch = (newValue: string) => {
        if (onSearch !== undefined && onFetchDataResults !== undefined) {
            const delay = setTimeout(async () => {
                const response = await onSearch(newValue);
                onFetchDataResults(response);
            }, 300);

            return () => clearTimeout(delay);
        }

        return undefined;
    };

    const getHelperClasses = () => {
        let style = 'select-autocomplete-helper';

        if (error && helperText) {
            style += ' select-autocomplete-helper--error';
        }

        return style;
    };

    const getSelectErrorClass = () => {
        if (error && helperText) {
            return 'select-autocomplete-div--error';
        }

        return '';
    };

    const renderMsgError = () => {
        return (
            <>
                <SpanIcon />
                {helperText}
            </>
        );
    };

    return (
        <>
            <span
                className="select-autocomplete-label"
                data-testid={`${dataTestId}-label`}
            >
                {label}
            </span>
            <Select
                showSearch
                onSearch={handleSearch}
                options={(props.options ?? []).map(d => ({
                    value: d.value,
                    label: d.label,
                }))}
                filterOption={
                    props.filterOption ??
                    ((input, option) =>
                        (option?.label?.toString() ?? '')
                            .toLowerCase()
                            .includes(input.toLowerCase()))
                }
                notFoundContent={null}
                suffixIcon={<CgChevronDown color="#0e0e0e" size={24} />}
                className={`${props.className} ${getSelectErrorClass()}`}
                data-testid={dataTestId}
                {...props}
            />
            <span className={getHelperClasses()}>
                {error && renderMsgError()}
            </span>
        </>
    );
}

export default SelectAutocomplete;
